// extracted by mini-css-extract-plugin
export default {"highAttention":"index_highAttention_8RbLg","leftImgOne":"index_leftImgOne_ZlG0y","rightImgOne":"index_rightImgOne_phXQQ","highAttentionText":"index_highAttentionText_vHiHy"};